module.exports = __webpack_public_path__ + "media/flags/panama-32-384d8eeb.png";